import { render, staticRenderFns } from "./pageThree.vue?vue&type=template&id=15f63bad&scoped=true&"
import script from "./pageThree.vue?vue&type=script&lang=js&"
export * from "./pageThree.vue?vue&type=script&lang=js&"
import style0 from "./pageThree.vue?vue&type=style&index=0&id=15f63bad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f63bad",
  null
  
)

export default component.exports